import type { Location } from "@be-miniapp/types"

import { httpPost } from "../http"

export interface v2GetCouponsParams {
  prefer_payment_mode?: number
  vehicle_type?: number
  other_promos_limit: number
  pickup_location: Location
  drop_location?: Location
  card_id?: string
  business_id?: string
}

export interface v2GetCouponsResponse {
  code: number
  other_promos_total: number
  user_promos: any[]
  other_promos: Otherpromo[]
}

export interface Otherpromo {
  id: number
  type: number
  title: string
  subtitle: string
  description: string
  can_use: boolean
  can_use_code: number
  can_use_remaining: number
  end_on: string
  allowed_vehicles: number[]
  label: string
  remaining_time: string
  is_item_selected: boolean
  icon_url: string
  header_img_url: string
  priority: number
  remaining_time_color: string
  coupon_id: string
  discount_amount: number
  msg: string
  start_from: string
}

export function v2GetCoupons(body: v2GetCouponsParams) {
  return httpPost<v2GetCouponsResponse>(
    "be-promo/customer/v2/get_coupons",
    body
  ).then((res) => res.data)
}

export interface v1EnterCodeParams {
  code: string
}

export interface v1EnterCodeResponse {
  code: number
  message: string
  coupon: Coupon
  result: boolean
}

interface Coupon {
  id: string
  service_id: number
  title_en: string
  title: string
  subtitle_en: string
  subtitle: string
  coupon_id: string
  auto_apply: number
  is_active: number
}

export function v1EnterCouponCode(body: v1EnterCodeParams) {
  return httpPost<v1EnterCodeResponse>(
    "be-voucher-admin/customer/redeem_code_be_promo",
    body
  ).then((res) => res.data)
}
